"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatBadgeText = exports.upperCaseWords = void 0;
// return the passed in string with the first letter of each word capitalized
function upperCaseWords(string) {
    return string
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}
exports.upperCaseWords = upperCaseWords;
// returns string formatted as a badge text
function formatBadgeText(string) {
    return upperCaseWords(string.replace(/_/g, ' '));
}
exports.formatBadgeText = formatBadgeText;
//# sourceMappingURL=utils.js.map